import dayjs from 'dayjs';

export function formatDate(
  date?: Date | number | string | null,
  options?: {
    daysToAdd?: number;
    defaultValue?: string;
    format?: string;
  },
) {
  if (!date) {
    return options?.defaultValue || '';
  }

  const formatted = dayjs(date)
    .add(options?.daysToAdd || 0, 'day')
    .format(options?.format || 'DD/MM/YYYY');
  return formatted;
}
